import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "table-card" }
const _hoisted_3 = { class: "filter-bar" }
const _hoisted_4 = { class: "filter-section" }
const _hoisted_5 = { class: "filter-btn dropdown-button" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "bulk-actions"
}
const _hoisted_8 = { class: "bulk-card" }
const _hoisted_9 = { class: "bulk-info" }
const _hoisted_10 = { class: "selection-count" }
const _hoisted_11 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_12 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "navigation-bar" }
const _hoisted_15 = { class: "left-controls" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "pro-badge"
}
const _hoisted_19 = { class: "right-controls" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "table-container" }
const _hoisted_23 = { class: "lots-table" }
const _hoisted_24 = { class: "checkbox-header" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = { class: "checkbox-cell" }
const _hoisted_27 = ["checked", "onChange"]
const _hoisted_28 = { class: "sticky-column lot-cell" }
const _hoisted_29 = { class: "sticky-column status-cell" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["type", "value"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "docs-display" }
const _hoisted_36 = { class: "docs-count" }
const _hoisted_37 = ["type", "value"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "buyers-display"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "buyer-names" }
const _hoisted_42 = {
  key: 0,
  class: "buyer-name"
}
const _hoisted_43 = {
  key: 1,
  class: "buyer-name"
}
const _hoisted_44 = {
  key: 1,
  class: "buyers-display empty"
}
const _hoisted_45 = ["src"]
const _hoisted_46 = {
  key: 0,
  class: "badge conditions-badge"
}
const _hoisted_47 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goBack')))
          }, "←"),
          _createVNode($setup["DropDown"], null, {
            control: _withCtx(() => [
              _createElementVNode("button", _hoisted_5, _toDisplayString($setup.displayStatus($props.activeFilter.label)), 1)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: filter.value,
                    onClick: ($event: any) => (_ctx.$emit('changeFilter', filter)),
                    class: _normalizeClass({ active: $setup.isActiveFilter(filter.value) })
                  }, _toDisplayString($setup.displayStatus(filter.label)), 11, _hoisted_6))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        ($setup.hasSelectedLots)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.selectionText), 1),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "selection-description" }, "Update status for all selected lots", -1))
                ]),
                _createElementVNode("button", {
                  class: "update-status-btn",
                  onClick: $setup.openBulkStatusModal
                }, "Update Status")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      ($props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("div", { class: "spinner" }, null, -1)
          ]))]))
        : ($setup.isEmpty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("img", {
                class: "empty-icon",
                src: require('@/assets/icons/lot-slim.svg')
              }, null, 8, _hoisted_13),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "empty-text" }, "You don't have any lots yet", -1))
            ]))
          : (!$props.isLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ($setup.isMobile)
                  ? (_openBlock(), _createBlock($setup["LotsCardView"], {
                      key: 0,
                      lots: $props.lots,
                      visibleColumns: $setup.visibleColumns,
                      editingLot: $props.editingLot,
                      editingField: $props.editingField,
                      editingValue: $props.editingValue,
                      getFieldType: $props.getFieldType,
                      getColumnDisplayValue: $props.getColumnDisplayValue,
                      isFieldEditable: $props.isFieldEditable,
                      isEditing: $setup.cardViewIsEditing,
                      startEdit: $setup.cardViewStartEdit,
                      openStatusModal: $setup.openStatusModal,
                      openEditPriceModal: $setup.cardViewOpenEditPriceModal,
                      displayStatus: $setup.displayStatus,
                      getStatusForClass: $setup.getStatusForClass,
                      getLotStatusClass: $setup.getLotStatusClass,
                      canCustomizeColumns: $setup.canCustomizeColumns,
                      onUpdateEditingValue: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateEditingValue', $event))),
                      onSaveEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saveEdit'))),
                      onCancelEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancelEdit'))),
                      onToggleCustomizeColumns: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggleCustomizeColumns')))
                    }, null, 8, ["lots", "visibleColumns", "editingLot", "editingField", "editingValue", "getFieldType", "getColumnDisplayValue", "isFieldEditable", "getLotStatusClass", "canCustomizeColumns"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["customize-btn", { 'tier2-enabled': $setup.canCustomizeColumns }]),
                            onClick: $setup.handleCustomizeClick,
                            disabled: !$setup.canCustomizeColumns
                          }, [
                            _createElementVNode("img", {
                              src: require('@/assets/icons/icon-settings.svg')
                            }, null, 8, _hoisted_17),
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "customize-text" }, "Customise Columns", -1)),
                            (!$setup.canCustomizeColumns)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, "PRO"))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_16)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "scroll-hint" }, "Scroll to view more columns", -1)),
                          _createElementVNode("button", {
                            class: "scroll-btn",
                            disabled: !$setup.canScrollLeft,
                            onClick: $setup.scrollLeft
                          }, "◀", 8, _hoisted_20),
                          _createElementVNode("button", {
                            class: "scroll-btn",
                            disabled: !$setup.canScrollRight,
                            onClick: $setup.scrollRight
                          }, "▶", 8, _hoisted_21)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", {
                          class: "table-scroll",
                          ref: "scrollContainer",
                          onScroll: $setup.updateScrollState
                        }, [
                          _createElementVNode("table", _hoisted_23, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_24, [
                                  _createElementVNode("input", {
                                    class: "checkbox-input",
                                    type: "checkbox",
                                    checked: $props.isSelectAll,
                                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('selectAll', $event.target.checked)))
                                  }, null, 40, _hoisted_25)
                                ]),
                                _cache[19] || (_cache[19] = _createElementVNode("th", { class: "sticky-column lot-header" }, "Lot No.", -1)),
                                _cache[20] || (_cache[20] = _createElementVNode("th", { class: "sticky-column status-header" }, "Status", -1)),
                                _cache[21] || (_cache[21] = _createElementVNode("th", { class: "standard-header price-header" }, "Price", -1)),
                                _createElementVNode("th", {
                                  class: _normalizeClass(["standard-header size-header", { disabled: !$props.isFieldEditable('size') }])
                                }, "Size m²", 2),
                                _cache[22] || (_cache[22] = _createElementVNode("th", { class: "standard-header docs-header" }, "Docs", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleColumns, (column) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    class: _normalizeClass(["standard-header", { disabled: !$props.isFieldEditable(column.key), 'buyers-header': column.key === 'lotBuyers', 'deposit-header': column.key === 'deposit', 'conditions-header': column.key === 'conditions', 'settlement-header': column.key === 'settlement' }]),
                                    key: column.key
                                  }, _toDisplayString(column.value), 3))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lots, (lot, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: lot._id
                                }, [
                                  _createElementVNode("td", _hoisted_26, [
                                    _createElementVNode("input", {
                                      class: "checkbox-input",
                                      type: "checkbox",
                                      checked: $props.selectedLotsList.some((selected) => selected.id === lot._id),
                                      onChange: ($event: any) => (_ctx.$emit('selectLot', $event.target.checked, index))
                                    }, null, 40, _hoisted_27)
                                  ]),
                                  _createElementVNode("td", _hoisted_28, [
                                    _createElementVNode("span", null, "Lot " + _toDisplayString(lot.title), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_29, [
                                    _createElementVNode("div", {
                                      class: "status-badges",
                                      onClick: _withModifiers(($event: any) => ($setup.openStatusModal(lot)), ["stop"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["badge", $setup.getLotStatusClass($setup.getStatusForClass(lot.status))])
                                      }, _toDisplayString($setup.displayStatus(lot.status)), 3)
                                    ], 8, _hoisted_30)
                                  ]),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["standard-cell price-cell", { disabled: !$props.isFieldEditable('price') }])
                                  }, [
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (_ctx.$emit('openEditPriceModal', lot)),
                                      class: _normalizeClass({ disabled: !$props.isFieldEditable('price') })
                                    }, _toDisplayString($props.getColumnDisplayValue(lot, "price")), 11, _hoisted_31)
                                  ], 2),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["standard-cell size-cell", { disabled: !$props.isFieldEditable('size') }])
                                  }, [
                                    ($setup.isEditing(lot._id, 'size'))
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: $props.getFieldType('size'),
                                          value: $props.editingValue,
                                          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('updateEditingValue', $event.target.value))),
                                          onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('saveEdit'))),
                                          onKeyup: [
                                            _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$emit('saveEdit')), ["enter"])),
                                            _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.$emit('cancelEdit')), ["escape"]))
                                          ]
                                        }, null, 40, _hoisted_32))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          onClick: ($event: any) => ($setup.startEdit(lot._id, 'size')),
                                          class: _normalizeClass({ disabled: !$props.isFieldEditable('size') })
                                        }, _toDisplayString($props.getColumnDisplayValue(lot, "size")), 11, _hoisted_33))
                                  ], 2),
                                  _createElementVNode("td", {
                                    class: "standard-cell docs-cell",
                                    onClick: ($event: any) => ($setup.openDocumentsModal(lot))
                                  }, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createVNode($setup["FileText"], {
                                        class: "docs-icon",
                                        size: 16
                                      }),
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(lot.documents?.length || 0), 1)
                                    ])
                                  ], 8, _hoisted_34),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleColumns, (column) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      class: _normalizeClass(["standard-cell", { disabled: !$props.isFieldEditable(column.key), 'buyers-cell': column.key === 'lotBuyers', 'deposit-cell': column.key === 'deposit', 'conditions-cell': column.key === 'conditions', 'settlement-cell': column.key === 'settlement' }]),
                                      key: column.key
                                    }, [
                                      ($setup.isEditing(lot._id, column.key))
                                        ? (_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: $props.getFieldType(column.key),
                                            value: $props.editingValue,
                                            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('updateEditingValue', $event.target.value))),
                                            onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('saveEdit'))),
                                            onKeyup: [
                                              _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.$emit('saveEdit')), ["enter"])),
                                              _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.$emit('cancelEdit')), ["escape"]))
                                            ]
                                          }, null, 40, _hoisted_37))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            onClick: ($event: any) => ($setup.startEdit(lot._id, column.key)),
                                            class: _normalizeClass({ disabled: !$props.isFieldEditable(column.key) })
                                          }, [
                                            (column.key === 'lotBuyers')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  ($props.getColumnDisplayValue(lot, column.key) !== '--')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                        _createElementVNode("img", {
                                                          class: "buyer-icon",
                                                          src: require('@/assets/icons/users-icon.svg')
                                                        }, null, 8, _hoisted_40),
                                                        _createElementVNode("div", _hoisted_41, [
                                                          (lot.lotBuyers?.firstBuyer)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(lot.lotBuyers.firstBuyer), 1))
                                                            : _createCommentVNode("", true),
                                                          (lot.lotBuyers?.secondBuyer)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(lot.lotBuyers.secondBuyer), 1))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                        _createElementVNode("img", {
                                                          class: "buyer-icon",
                                                          src: require('@/assets/icons/users-icon.svg')
                                                        }, null, 8, _hoisted_45),
                                                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "buyer-names" }, "--", -1))
                                                      ]))
                                                ], 64))
                                              : (column.key === 'conditions')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    ($props.getColumnDisplayValue(lot, column.key) !== '--')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString($props.getColumnDisplayValue(lot, column.key)), 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_47, "--"))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createTextVNode(_toDisplayString($props.getColumnDisplayValue(lot, column.key)), 1)
                                                  ], 64))
                                          ], 10, _hoisted_38))
                                    ], 2))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 544)
                      ])
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
    ]),
    _createVNode($setup["StatusUpdateModal"], {
      isOpen: $setup.showStatusModal,
      lotTitle: $setup.selectedLot?.title || '',
      currentStatus: $setup.selectedLot?.status || '',
      options: $props.getFieldOptions('status'),
      onClose: $setup.closeStatusModal,
      onConfirm: $setup.handleStatusUpdate
    }, null, 8, ["isOpen", "lotTitle", "currentStatus", "options"]),
    _createVNode($setup["BulkStatusUpdateModal"], {
      isOpen: $setup.showBulkStatusModal,
      selectedLotsCount: $props.selectedLotsList.length,
      availableStatuses: $props.getFieldOptions('status'),
      onClose: $setup.closeBulkStatusModal,
      onConfirm: $setup.handleBulkStatusUpdate
    }, null, 8, ["isOpen", "selectedLotsCount", "availableStatuses"]),
    _createVNode($setup["EditBuyersModal"], {
      isOpen: $setup.showBuyersModal,
      currentBuyers: $setup.selectedLot?.lotBuyers || null,
      onClose: $setup.closeBuyersModal,
      onConfirm: $setup.handleBuyersUpdate
    }, null, 8, ["isOpen", "currentBuyers"]),
    _createVNode($setup["ConditionsModal"], {
      isOpen: $setup.showConditionsModal,
      lotTitle: $setup.selectedLot?.title || '',
      currentCondition: $setup.selectedLot?.conditions || '',
      options: $setup.conditionsOptions,
      onClose: $setup.closeConditionsModal,
      onConfirm: $setup.handleConditionsUpdate
    }, null, 8, ["isOpen", "lotTitle", "currentCondition", "options"]),
    _createVNode($setup["CancelHoldModal"], {
      isOpen: $setup.showCancelHoldModal,
      lotTitle: $setup.cancelHoldModalTitle,
      currentStatus: $setup.cancelHoldCurrentStatus,
      onClose: $setup.closeCancelHoldModal,
      onConfirm: $setup.handleCancelHoldConfirm
    }, null, 8, ["isOpen", "lotTitle", "currentStatus"]),
    _createVNode($setup["SetHoldBuyersModal"], {
      isOpen: $setup.showSetHoldBuyersModal,
      lotTitle: $setup.setHoldModalTitle,
      status: $setup.pendingStatusWithBuyers,
      existingBuyers: $setup.pendingSetHoldLot?.lotBuyers,
      onClose: $setup.closeSetHoldBuyersModal,
      onConfirm: $setup.handleSetHoldConfirm
    }, null, 8, ["isOpen", "lotTitle", "status", "existingBuyers"]),
    _createVNode($setup["BulkSetBuyersModal"], {
      isOpen: $setup.showBulkSetBuyersModal,
      lots: $setup.bulkLotsForBuyers,
      status: $setup.pendingStatusWithBuyers,
      existingBuyers: $setup.existingBuyersForBulk,
      onClose: $setup.closeBulkSetBuyersModal,
      onConfirm: $setup.handleBulkSetBuyersConfirm,
      onSkip: $setup.handleBulkSetBuyersSkip
    }, null, 8, ["isOpen", "lots", "status", "existingBuyers"]),
    _createVNode($setup["LotDocumentsModal"], {
      isOpen: $setup.showDocumentsModal,
      lotId: $setup.selectedLotForDocuments?._id || '',
      lotTitle: $setup.selectedLotForDocuments?.title || '',
      documents: $setup.selectedLotForDocuments?.documents || [],
      onClose: $setup.closeDocumentsModal,
      onRefresh: $setup.handleDocumentsRefresh
    }, null, 8, ["isOpen", "lotId", "lotTitle", "documents"])
  ]))
}